// Example starter JavaScript for disabling form submissions if there are invalid fields
(function () {
  'use strict'

  // Fetch all the forms we want to apply custom Bootstrap validation styles to
  var forms = document.querySelectorAll('.needs-validation')

  // Loop over them and prevent submission
  Array.prototype.slice.call(forms)
    .forEach(function (form) {
      form.addEventListener('submit', function (event) {
        if (!form.checkValidity()) {
          event.preventDefault()
          event.stopPropagation()
        }

        form.classList.add('was-validated')
      }, false)
    })
})()

// When the user clicks on the button, scroll to the top of the document
function topFunction() {
	$("html, body").animate({ scrollTop: 0 });
}

function sidebar_open() {
  $('html').addClass('overflow-hidden');
  $("#menuSidebar").addClass('sidebar-open');
}

function sidebar_close() {
  $('html').removeClass('overflow-hidden');
  $("#menuSidebar").removeClass('sidebar-open');
}